export const VIEW_NUMBERS_LIST = 101
export const RESERVE_NUMBER    = 102
export const SELL_NUMBER       = 103
export const IMPORT_NUMBER     = 104